import { APICallV3Get } from 'reactApp/api/APICall';

export class SubscriptionListAPICall extends APICallV3Get {
    _method = 'billing/subscription/list';
}
